import Vue from 'vue';

// When the request succeeds
const success = () => {
  Vue.router.push({
    name: 'user.view',
  });
};

// When the request fails
const failed = () => {};

export default (user) => {
  if (!user.password || !user.passwordConfirmation) {
    failed();
  } else if (user.password !== user.passwordConfirmation) {
    failed();
  } else {
    Vue.$http
      .post('users', user)
      .then((response) => {
        success(response);
      })
      .catch((error) => {
        failed(error);
      });
  }
};



// WEBPACK FOOTER //
// ./src/services/auth/register.js